<template>
	<div id="admin-menu">
		<!-- 사용자 표시 -->
		<div class="hover-leftline pt-4 px-3" v-on:click="goDashboard" style="cursor: pointer">
			<img class="topbar-logo" src="../../src/assets/images/spade-logo.png" />
			<br>
		</div>
		<hr>

		<ul class="nav d-flex flex-column">
			<!-- Dashboard -->
			<li class="nav-item">
				<a href="javascript:void(0);" class="menu-link" :class="{ active: link1 }" v-on:click="goDashboard">
					<i class="fas fa-running"></i> Dashboard
				</a>
			</li>

			<!-- RDA Case DownLoad -->
			<li class="nav-item">
				<a href="javascript:void(0);" class="menu-link" :class="{ active: link2 }" v-on:click="goNotification">
					<i class="fas fa-flag-checkered"></i> Notification
				</a>
			</li>

			<!-- Sample Test (TasksInProgress)-->
			<li class="nav-item">
				<a href="javascript:void(0);" class="menu-link" :class="{ active: link3 }" v-on:click="goScript">
					<i class="fas fa-magic"></i> Script
				</a>
			</li>

			<li class="nav-item">
				<a href="javascript:void(0);" class="menu-link" :class="{ active: link4 }" v-on:click="goStatistics">
					<i class="fas fa-chart-bar"></i> Statistics
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: "SideBar2",
	data() {
		return {
			link1: false,
			link2: false,
			link3: false,
			link4: false,
		}
	},
	methods: {
		goDashboard: function (event) {
			this.menuClear();
			//   if (!this.link1) {
			// 	this.link1 = true;
			//   }
			this.$router.push("/dashboard");
		},
		goNotification: function (event) {
			this.menuClear();
			//   if (!this.link2) {
			//     this.link2 = true;
			//   }
			this.$router.push('/notification');
		},
		goScript: function (event) {
			this.menuClear();
			//   if (!this.link3) {
			//     this.link3 = true;
			//   }
			this.$router.push('/script');
		},
		goStatistics: function (event) {
			this.menuClear();
			//   if (!this.link4) {
			//     this.link4 = true;
			//   }
			this.$router.push('/statistics');
		},
		signOut() {
			this.$store.dispatch('auth/logout');
			this.$router.push('/signIn');
		},
		passwordModify() {
			this.$router.push("/passwordModifyPage")
		},
		menuClear() {
			this.link1 = false;
			this.link2 = false;
			this.link3 = false;
			this.link4 = false;
		},
	},
	computed: {
		signInUser() {
			let user = JSON.parse(localStorage.getItem('user'));

			if (user && user.caller && user.role) {
				// return user.caller + " (" + user.role + ")";
				return user.caller + " (" + user.role + ")" + " - " + user.tenant + "번";
			} else {
				return '';
			}
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
